const predicate = (priceRange) => (itinerary) => {
  const price = Math.ceil(itinerary.price.amount);
  return !priceRange || (price >= priceRange[0] && price <= priceRange[1]);
};

export default predicate;
